<template>
  <div class="bg">
    <!-- <img style="width: 100%;" src="@assets/img/at.png" alt="" srcset=""> -->
    <div class="innerBox">
      <div class="title">一、日期</div>
      <div class="time">{{ time }}</div>
      <div class="title">二、规则</div>
      <div class="time">
        问卷调查题目的答案确定后不可更改，跳转下个问题后无法返回上个问题。<br />
      </div>
      <van-button
        style="margin-top: 0.9rem"
        type="danger"
        block
        round
        @click="todati"
        >开始回答</van-button
      >
      <!-- <img class="foot" src="@/assets/img/footer.png" alt="" srcset="" /> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "vant";
import { getTime, creatSurvey } from "@api/answer";

Vue.use(Button);

export default {
  data() {
    return {
      time: "",
      status: 0,
      msg: "",
      count: "",
      point: 0,
    };
  },
  created() {
    this.getdate();
  },
  methods: {
    getdate() {
      getTime()
        .then((res) => {
          console.log(res);
          this.time = res.data.time;
        })
        .catch((err) => {});
    },
    todati() {
      creatSurvey()
        .then((res) => {
          this.$router.push({ path: "/answer/surveyList" });
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
        });
    },
  },
};
</script>

<style scoped>
.bg {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url("~@assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.innerBox {
  margin: 3%;
  background: #fdf9ee;
  border-radius: 0.2rem;
  position: absolute;
  bottom: 0;
  width: 94%;
  top: 0.2rem;
  right: 0;
  left: 0;
  padding: 0.34rem;
  color: #202020;
}
.title {
  font-size: 0.3rem;
  line-height: 0.5rem;
}
.time {
  font-size: 0.3rem;
  line-height: 0.5rem;
  padding: 0.1rem 0;
}
.foot {
  display: block;
  width: 80%;
  position: absolute;
  left: 10%;
  bottom: 0.3rem;
}
</style>
